import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import User from '_class/User';
import { connect } from 'react-redux';
import { translate } from '@haldor/ui';
import { Field, reduxForm } from 'redux-form';
import getEnvironment from 'lib/env';
import { getToken, loginRequest, http } from 'lib/msal';
import DropzoneComponent from 'react-dropzone-component';
import { Tags, Button, Icon } from '@haldor/ui';
import './_fileUpload.scss';

var FileUpload = /*#__PURE__*/function (_Component) {
  _inherits(FileUpload, _Component);

  var _super = _createSuper(FileUpload);

  function FileUpload(props) {
    var _this;

    _classCallCheck(this, FileUpload);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "dropzoneInit", function (dropzone) {
      _this.dropzone = dropzone;
    });

    _defineProperty(_assertThisInitialized(_this), "triggerDropzone", function () {
      if (_this.dropzone != null) {
        _this.dropzone.hiddenFileInput.click();
      }
    });

    _defineProperty(_assertThisInitialized(_this), "onAddFile", function (file) {
      var files = _this.state.files;
      files.push(file);
      setTimeout(function () {
        _this.setState({
          files: files
        });
      }, 40);
    });

    _defineProperty(_assertThisInitialized(_this), "onRemoveFile", function (file) {
      var files = _this.state.files;
      var fileIndex = files.findIndex(function (f) {
        return f.upload.filename === file.upload.filename;
      });
      files.splice(fileIndex, 1);

      _this.setState({
        files: files
      }, function () {
        if (_this.dropzone) {
          _this.dropzone.removeFile(file);
        }
      });
    });

    _defineProperty(_assertThisInitialized(_this), "uploadedFile", function (djsFile, response) {
      // Gets called every time a file is uploaded
      var files = _this.state.uploadedFiles;
      response.map(function (file) {
        files.push(file);
      });

      _this.setState({
        uploadedFiles: files
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onCancel", function (event) {
      event.preventDefault();

      if (_this.props.onCancel) {
        _this.props.onCancel();
      }
    });

    _defineProperty(_assertThisInitialized(_this), "submit", function (values) {
      return new Promise(function (resolve) {
        if (_this.dropzone && _this.dropzone.getQueuedFiles().length > 0) {
          _this.dropzone.processQueue();

          _this.dropzone.on("queuecomplete", function () {
            // Do something after all files are uploaded
            values.files = _this.state.uploadedFiles;

            if (_this.props.onSubmit != null) {
              _this.props.onSubmit(values).then(function () {
                resolve(1);
              });
            } else {
              resolve(1);
            }
          });
        } else {
          resolve(1);
        }
      });
    });

    _this.state = {
      files: [],
      uploadedFiles: []
    };
    _this.dropzone = null;
    var user = new User(props.currentUser);
    _this.componentConfig = {
      iconFiletypes: ['.jpg', '.png', '.gif'],
      showFiletypeIcon: false,
      postUrl: "".concat(http.defaults.baseURL, "users/").concat(props.userId, "/files?schoolId=").concat(user.getActiveSchool().id),
      dropzoneSelector: '.dropzone-trigger'
    };
    _this.djsConfig = {
      autoProcessQueue: false,
      parallelUploads: 2,
      maxFilesize: 3,
      headers: {}
    };
    loginRequest.scopes = getEnvironment().scopes;
    getToken(loginRequest).then(function (response) {
      _this.djsConfig.headers['Authorization'] = 'Bearer ' + response.accessToken;
    });
    _this.dropzoneEvents = {
      init: _this.dropzoneInit,
      addedfile: _this.onAddFile,
      success: _this.uploadedFile
    };
    return _this;
  }

  _createClass(FileUpload, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          submitting = _this$props.submitting,
          handleSubmit = _this$props.handleSubmit,
          translate = _this$props.translate;
      return /*#__PURE__*/React.createElement("div", {
        className: "form-container"
      }, submitting ? /*#__PURE__*/React.createElement("div", {
        className: "is_sending"
      }, /*#__PURE__*/React.createElement("p", null, /*#__PURE__*/React.createElement("span", {
        className: "loading-spinner"
      }))) : null, /*#__PURE__*/React.createElement("form", {
        onSubmit: handleSubmit(this.submit),
        className: "form form-component file-upload"
      }, /*#__PURE__*/React.createElement("div", {
        className: "form-row"
      }, /*#__PURE__*/React.createElement("label", {
        style: {
          marginTop: 0
        }
      }, translate('open-sharepoint-onedrive')), /*#__PURE__*/React.createElement("div", {
        className: "dropzone-trigger icon-container",
        style: {
          height: 'auto',
          width: '100%'
        },
        onClick: this.triggerDropzone
      }, /*#__PURE__*/React.createElement("div", {
        className: "icon"
      }, /*#__PURE__*/React.createElement(Icon, {
        name: "File"
      })), /*#__PURE__*/React.createElement("div", {
        className: "text"
      }, this.props.translate('drop-files-or-click-here')), /*#__PURE__*/React.createElement(DropzoneComponent, {
        djsConfig: this.djsConfig,
        eventHandlers: this.dropzoneEvents,
        config: this.componentConfig
      }))), this.state.files.length > 0 ? /*#__PURE__*/React.createElement("div", {
        className: "form-row file-list"
      }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("label", null, translate('files-on-queue'))), this.state.files.map(function (file, index) {
        return /*#__PURE__*/React.createElement("div", {
          key: 'file-' + index,
          className: "file-preview ".concat(file.upload.progress > 0 ? ' upload-started' : ' not-started')
        }, /*#__PURE__*/React.createElement("div", {
          style: {
            cursor: 'pointer',
            marginRight: '0.6rem'
          },
          onClick: function onClick() {
            return _this2.onRemoveFile(file);
          }
        }, /*#__PURE__*/React.createElement(Icon, {
          name: "Bin"
        })), /*#__PURE__*/React.createElement("div", {
          className: "file-name"
        }, file.name), /*#__PURE__*/React.createElement("div", {
          className: "file-progress"
        }, /*#__PURE__*/React.createElement("div", {
          style: {
            width: file.upload.progress + '%'
          },
          className: "file-progress-bar"
        })));
      })) : null, /*#__PURE__*/React.createElement("div", {
        className: "form-row"
      }, /*#__PURE__*/React.createElement("label", null, translate('Add tag')), /*#__PURE__*/React.createElement(Field, {
        component: Tags,
        name: "tags"
      })), /*#__PURE__*/React.createElement("div", {
        className: "form-divider"
      }), /*#__PURE__*/React.createElement("div", {
        className: "form-row spacing submit"
      }, /*#__PURE__*/React.createElement(Button, {
        disabled: submitting,
        type: "primary"
      }, translate('upload')), /*#__PURE__*/React.createElement("div", {
        className: "align-right"
      }, /*#__PURE__*/React.createElement(Button, {
        onClick: this.onCancel,
        disabled: submitting,
        type: "secondary"
      }, this.props.translate('Cancel'))))));
    }
  }]);

  return FileUpload;
}(Component);

function mapStateToProps(state) {
  return {
    currentUser: state.user.currentUser,
    translate: translate(state.Languages.translations)
  };
}

export default connect(mapStateToProps)(reduxForm({
  form: 'FileUpload',
  destroyOnUnmount: true
})(FileUpload));